// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z93V","col":"styles_col__2f6Ip"};